import React from 'react';
interface ConsentChecksProps {
  consent: boolean;
  contact: boolean;
  onConsent: (v: boolean) => void;
  onContact: (v: boolean) => void;
  error?: string;
  purpose: string;
}
export function ConsentChecks({
  consent,
  contact,
  onConsent,
  onContact,
  error,
  purpose
}: ConsentChecksProps) {
  return <div className="space-y-2 rounded-xl border border-line p-3" data-id="element-457" data-mp="312jfptekon8y">
      <label className="flex items-start gap-3 text-xs text-mist" data-id="element-458" data-mp="3osx6lglf8g1y">
        <input type="checkbox" checked={consent} onChange={e => onConsent(e.target.checked)} className="mt-0.5 h-4 w-4" aria-invalid={!!error} data-id="element-459" data-mp="3otp3qvuo2luc" />
        <span data-id="element-460" data-mp="3f3ngg6a517gh">
          Presto mi consentimiento informado para que VCARS trate estos datos con el único fin de {purpose}, conforme a la Ley 25.326. Puedo solicitar su acceso,
          rectificación o supresión en cualquier momento.
        </span>
      </label>
      <label className="flex items-start gap-3 text-xs text-mist" data-id="element-461" data-mp="bkaogmqx4cd1">
        <input type="checkbox" checked={contact} onChange={e => onContact(e.target.checked)} className="mt-0.5 h-4 w-4" data-id="element-462" data-mp="gdvmgesih6c8" />
        <span data-id="element-463" data-mp="329hsqbnzsm93">Acepto que un asesor comercial me contacte.</span>
      </label>
      {error && <p className="text-xs text-danger" role="alert" data-id="element-464" data-mp="2xbyaz1s35rce">
          {error}
        </p>}
    </div>;
}